import { Component, Vue } from 'vue-property-decorator';
import { getStyleSkinName } from '@/tools/helpers.ts';

@Component<Navigation>({
  components: {
  },
})
export default class Navigation extends Vue {
  protected getStyle: any = getStyleSkinName();
  protected isScrolled: boolean = false;

  public mounted() {
    //
  }

  public created() {
    window.addEventListener('scroll', this.checkScroll);
  }

  public destroyed() {
    window.removeEventListener('scroll', this.checkScroll);
  }

  protected logout() {
    this.$store.dispatch('setUser', null);
    this.$router.push('login');
  }

  protected checkScroll() {
    const scrollObject = {
      y: window.pageYOffset
    }
    
    if (scrollObject.y > 30) this.isScrolled = true;
    if (scrollObject.y < 30) this.isScrolled = false;
  }

  protected getUserImage() {
    if (!this.$store.state.user) return require('@/assets/images/profile.png');
    if (this.$store.state.user.picture) return this.$store.state.user.picture;
  }

  protected showNavigation() {
    if (this.$route.name === 'confirmation page') return false;
    return true;
  }

}
